import { Column } from "../decorators/column";
import { autoserializeAs } from "cerializr";

export class NoOfPatientsWhoUnderwentCochlearImplantReport {
    @autoserializeAs(String)
    @Column({
        columnName: 'Brand'
    })
    brand: string;
    @autoserializeAs(String)
    @Column({
        columnName: 'Count'
    })
    count: string;
    @autoserializeAs(String)
    @Column({
        columnName: 'Percent'
    })
    percent: string;
}
